export class User {
  id: number = null;
  email: string = null;
  firstName: string = null;
  lastName: string = null;
  phone: string = null;
}
